import './HomePage.css';
import React, { useState } from 'react';
import HomeSection from '../../components/Sections/HomeSection/HomeSection';
import AboutSection from '../../components/Sections/AboutSection/AboutSection';
import ContactSection from '../../components/Sections/ContactSection/ContactSection';
import OfferingsSection from '../../components/Sections/OfferingsSection/OfferingsSection';
import NavBar from '../../components/Navigation/NavBar';
import Footer from '../../components/Sections/Footer/Footer';
import MobileNavigationBar from '../../components/Navigation/MobileNavigationBar';
import TestimonialsSection from '../../components/Sections/TestimonialsSection/TestimonialsSection';
import { PageProps } from '../../models/PageProps';


function HomePage({smallScreen}: PageProps) {

  const [showMessageBanner, setShowMessageBanner] = useState(true)

  return (
    <>
      <div className="background-image" />
      <div>
        {smallScreen ? <MobileNavigationBar setShowMessageBanner={setShowMessageBanner} showMessageBanner={showMessageBanner} /> :<NavBar setShowMessageBanner={setShowMessageBanner} showMessageBanner={showMessageBanner}/>}
        <HomeSection />
        <OfferingsSection />
        <AboutSection />
        <TestimonialsSection />
        <ContactSection />
        <Footer />
      </div>
    </>
  );
}

export default HomePage;
